import { MixContractDelegateType, MixContractHoldSide } from 'constants/MixContractGlobal'

/**
 * 判断委托类型是开多还是开空
 * @param delegateType
 * @returns
 */
const delegateType2Holdside = (delegateType: MixContractDelegateType): MixContractHoldSide => {
    if (
        delegateType === MixContractDelegateType.OPEN_LONG ||
        delegateType === MixContractDelegateType.BUY_IN_SINGLE_SIDE_MODE ||
        delegateType === MixContractDelegateType.CLOSE_SHORT
    ) {
        // 开多仓
        return MixContractHoldSide.LONG_POSITIONS
    }
    // 开空仓
    return MixContractHoldSide.SHORT_POSITIONS
}
export default delegateType2Holdside
